import { render, staticRenderFns } from "./SecurityPoint.vue?vue&type=template&id=4aaafae3&"
import script from "./SecurityPoint.vue?vue&type=script&lang=js&"
export * from "./SecurityPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports